export default __webpack_public_path__ + "static/color-blindness-cbf393c8dda15557c74508d77fffbcff.mp4";